import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "fileInput", "kind", "dropzone", "lightbox", "lightboxContent"]

  openPicker() {
    this.fileInputTarget.click()
  }

  uploadSelected() {
    const file = this.fileInputTarget.files?.[0]
    if (!file) return

    this.kindTarget.value = file.type?.startsWith("video/") ? "video" : "photo"
    this.formTarget.requestSubmit()
  }

  dragOver(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.add("border-emerald-400/50", "bg-emerald-500/10")
  }

  dragLeave(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove("border-emerald-400/50", "bg-emerald-500/10")
  }

  drop(event) {
    event.preventDefault()
    this.dragLeave(event)

    const file = event.dataTransfer?.files?.[0]
    if (!file) return

    const transfer = new DataTransfer()
    transfer.items.add(file)
    this.fileInputTarget.files = transfer.files
    this.uploadSelected()
  }

  submitAssociation(event) {
    event.target.form?.requestSubmit()
  }

  openLightbox(event) {
    event.preventDefault()
    event.stopPropagation()

    const { url, kind } = event.params
    this.lightboxContentTarget.innerHTML = kind === "video"
      ? `<video src="${url}" controls autoplay class="max-h-[85vh] max-w-full rounded-2xl shadow-2xl"></video>`
      : `<img src="${url}" class="max-h-[85vh] max-w-full rounded-2xl object-contain shadow-2xl" alt="Evidence preview">`

    this.lightboxTarget.classList.remove("hidden")
    this.lightboxTarget.classList.add("flex")
  }

  closeLightbox(event) {
    event.preventDefault()

    if (event.target !== this.lightboxTarget && !event.target.closest("button")) return

    this.lightboxTarget.classList.add("hidden")
    this.lightboxTarget.classList.remove("flex")
    this.lightboxContentTarget.innerHTML = ""
  }
}
